/* import __COLOCATED_TEMPLATE__ from './header.hbs'; */
/* RESPONSIBLE TEAM: team-knowledge-foundations */
import Component from '@glimmer/component';
import type ArticleContent from 'embercom/models/articles/article-content';
import { inject as service } from '@ember/service';
import type KnowledgeHubEditorService from 'embercom/services/knowledge-hub-editor-service';
import { type ScheduleMode } from 'embercom/lib/knowledge-hub/constants';

export interface Args {
  activeContent: ArticleContent;
  showSidePanel: boolean;
  cancelEditActiveContent: () => void;
  saveActiveContent: () => void;
  publishActiveContent: () => Promise<void>;
  toggleSidePanel: () => void;
  scheduleActiveContentUpdate: (params: {
    mode: ScheduleMode;
    scheduledDate: Date;
  }) => Promise<void>;
}

interface Signature {
  Args: Args;
}

export default class Header extends Component<Signature> {
  @service declare knowledgeHubEditorService: KnowledgeHubEditorService;

  get isComposerUploading() {
    return this.knowledgeHubEditorService.isComposerUploading;
  }
}

declare module '@glint/environment-ember-loose/registry' {
  export default interface Registry {
    'KnowledgeHub::ContentEditor::ArticleContent::Edit::Header': typeof Header;
    'knowledge-hub/content-editor/article-content/edit/header': typeof Header;
  }
}
